import axios from 'axios';
import { useStore } from 'vuex';

const autoLoginGuard = async (to, from, next) => {
    const store = useStore();

    return new Promise((resolve, reject) => {
        let header = { 'token': localStorage.getItem('token') }
        let config = { headers: header }
        axios.get('auth/token', config)
            .then((response) => {
                next({ name: 'menu' })
                const user = response.data;
                store.dispatch('saveUser', user);
                if (user.role !== 'Admin' ) {
                    this.$store.dispatch('saveBusiness', user.business[0]);
                }

            })
            .catch((error) => { next() });
    })
}
export default autoLoginGuard
